import { AddFilesModal, type AddFilesModalInitialTab } from '@/chat-common/components/source-dialogs/AddFilesModal'
import { kPdfOnlyFileTypeMessage } from '@/user_files/constants'

type StagedMatterFilesDialogProps = {
  open: boolean
  matterId: string | null
  initialSelectedIds: string[]
  initialTab?: AddFilesModalInitialTab
  onClose: () => void
  onApply: (userFileIds: string[]) => void
  pdfOnly?: boolean
  includeProcessingFiles?: boolean
}

/**
 * Matter Files picker shared by staging pages. Timeline keeps the default PDF restriction;
 * tables can opt into selecting uploaded documents that are still processing.
 */
export function StagedMatterFilesDialog({
  open,
  matterId,
  initialSelectedIds,
  initialTab,
  onClose,
  onApply,
  pdfOnly = true,
  includeProcessingFiles = false,
}: StagedMatterFilesDialogProps) {
  // AddFilesModal requires a non-null matterId; there is nothing to browse without one.
  if (!matterId) return null

  return (
    <AddFilesModal
      includeProcessingFiles={includeProcessingFiles}
      open={open}
      matterId={matterId}
      initialSelectedFileIds={initialSelectedIds}
      initialTab={initialTab}
      onClose={onClose}
      onFilesSelected={onApply}
      isFileSelectable={pdfOnly ? (file) => file.detected_content_type === 'application/pdf' : undefined}
      fileNotSelectableMessage={pdfOnly ? kPdfOnlyFileTypeMessage : undefined}
    />
  )
}
